import { useState, useEffect, useContext } from 'react'
import useGetVendorProductsQuery from '@src/hooks/queries/product/useGetVendorProductsQuery'
import { CenterModalContext } from '@src/contexts/popup/modal/CenterModalProvider'
import { useNavigate } from 'react-router-dom'
import type { Product } from '@src/type/product'

type ParamTypes = {
	limit: number
}
function useProductList({ limit }: ParamTypes) {
	const navigate = useNavigate()
	const { openCenterModal, closeCenterModal } = useContext(CenterModalContext)
	const [products, setProducts] = useState<Product[]>([])
	const [keyword, setKeyword] = useState<string | null | undefined>(undefined)
	const { fetchNextPage, data, error, isFetching, refetch, isStale } = useGetVendorProductsQuery({
		limit,
		keyword: keyword || undefined,
	})

	useEffect(() => {
		const loadInit = () => {
			if (keyword !== undefined) {
				setProducts([])
				refetch({ stale: false }).catch(() => {})
			}
		}
		loadInit()
	}, [keyword, refetch])

	useEffect(() => {
		const receivedProductList = data?.pages.at(-1)
		if (receivedProductList) {
			setProducts((prevList) => [...prevList, ...receivedProductList])
		}
	}, [data])

	useEffect(() => {
		if (error?.response?.data?.error) {
			const errorData = error?.response?.data?.error
			if (errorData.detail_code === 'LOGIN_REQ') {
				openCenterModal({ desc: '로그인이 필요해요.' }, () => () => {
					navigate('/signin')
					closeCenterModal()
				})
			} else {
				openCenterModal({ desc: '예기치 못한 에러가 발생했어요' }, () => closeCenterModal)
			}
		}
	}, [closeCenterModal, error, navigate, openCenterModal])
	const removeProduct = (productNo: string) => {
		const newProduct = products.filter((product) => product.no !== productNo)
		setProducts(newProduct)
	}
	const handleChangeKeyword = (e: React.FormEvent<HTMLInputElement>) => {
		const newKeyword = e.currentTarget.value
		setKeyword(newKeyword.length === 0 ? null : newKeyword)
	}

	const getProjectListProps = ({ ...otherProps } = {}) => {
		return {
			products,
			isStale,
			fetchNextPage,
			isFetching,
			removeProduct,
			...otherProps,
		}
	}

	const getSearchBarProps = ({ ...otherProps } = {}) => {
		return {
			onChange: handleChangeKeyword,
			...otherProps,
		}
	}

	return {
		getSearchBarProps,
		getProjectListProps,
	}
}
export default useProductList
